<script setup lang="ts">
import IconTooltip from '@components/icons/icon-tooltip.vue';
import { createModalAbort } from '@utils/modal-util.ts';
import ItemInfo from '@components/item-info.vue';
import { ItemInfoProps } from '@components/composables/item-info-composable.ts';
import type { TooltipPositions } from '@components/tooltip-types.ts';
import ButtonIcon from '@components/buttons/button-icon.vue';

const props = defineProps<ItemInfoProps & { tooltipPosition?: TooltipPositions, buttonMode?: boolean }>();

function showProductDetails() {
    createModalAbort(
        false,
        ItemInfo,
        null,
        props,
    );
}
</script>

<template>
    <ButtonIcon v-if="buttonMode" icon="info-circle" :tooltip="{ tooltip: 'Produktdetails anzeigen' }" position="bottom_right" @click.stop="showProductDetails"/>
    <IconTooltip v-else icon="info-circle" tooltip="Produktdetails anzeigen" :position="tooltipPosition ?? 'right'" @click.stop="showProductDetails"/>
</template>
